
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import * as moment from 'moment';

import { TeemappTableComponent } from '@teem/shared-component/teemapp-table/teemapp-table.component';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import { UserCurrencyPipe } from '@teem/pipes/user-currency.pipe';
import { ngDebounce } from '@teem/decorators/debouce.decorator';
import { InvoiceService } from '@teem/services/invoice.service';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import { UserService } from '@teem/services/user.service';

import SettlementsTableSchema from '@teem/settlements-module/classes/settlements-table-schema';

declare var $;

@Component({
  selector: 'app-settlements',
  templateUrl: './settlements.component.html',
  styles: ['./settlements.component.css'],
  providers: [UserCurrencyPipe]
})
export class SettlementsComponent implements OnInit {
  @ViewChild('settlementsTableRef') settlementsTableRef: TeemappTableComponent;
 
  settlementsCount: number = 0;
  activeInvoice: any;
  allDepositsSum:number = 0;
  routeSubscriber: any;
  userInfo: any;
  permissions: any;

  // Received payments table scheme
  settlementsTable: SettlementsTableSchema = new SettlementsTableSchema(this);

  constructor(
    private invoiceService: InvoiceService,
    private loaderService: LoaderService,
    private userService: UserService,
    private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.loadCommonData();

    // Show/Hide whatsapp action as per pro plan
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data) {
        if (data.userInfo) {
          this.userInfo = data.userInfo
        }

        if (data.permissions) {
          this.permissions = data.permissions;
        }
      }
    })
  }

  loadCommonData() {
    this.invoiceService.stats().subscribe((data: any) => {
      this.allDepositsSum = data.deposits;
    })
  }

  fetchPermissions() {
    this.userService.getPermissions().subscribe((data: any) => {
      if (data) {
        this.sharedDataService.setItem('permissions', data);
      }
    });
  }

  filterByDate(params) {
    if (!(params.from_date || params.to_date)) {
      this.settlementsTableRef.resetDateFilters();
      this.settlementsTableRef.getPage(1);
    } else if (params.from_date && params.to_date) {
      this.settlementsTableRef.getPage(1, false, params);
    }
  }

  // function called after 2s
  @ngDebounce(500)
  filterByAmount(params) {
    this.settlementsTableRef.getPage(1, false, params);
  }

  filterByStatus(params) {
    this.settlementsTableRef.getPage(1, false, params);
  }

  // ngOnDestroy() {
  //   this.routeSubscriber.unsubscribe();
  // }

  switchTab(tab) {
    this.settlementsTableRef.reset();
  }

  searchInvoices(term: string) {
    this.settlementsTableRef.search.next(term);
  }

  onLoadSettlements(data: any) {
    this.settlementsCount = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

}



